export default {
  currentRoute: {},
  defaultDateFormat: 'L',
  hiddenAttributes: ['isCircle', 'color', 'importation_id'],
  initialDataLoaded: false,
  menuCollapsed: false,
  fullScreen: false,
  darkMode: false,
  // Navigation state
  sidebarVisible: true,
  quickSearchVisible: false
}
